import { useTranslation } from "react-i18next";
import { ThemeProvider } from "styled-components";
import { AboutMe } from "../components/AboutMe";
import { Bio } from "../components/Bio";
import { Header } from "../components/Header";
import { Projects } from "../components/Projects";
import { TechStack } from "../components/TechStack";
import { Contacts } from "../components/Contacts";
import { GlobalStyle } from "../styles/global";

import themes from "../styles/themes";
import usePersistedState from "../utils/usePersistedState";


export function Home() {
  const [theme, setTheme] = usePersistedState('theme', themes.dark);
  const { i18n } = useTranslation();

  const toggleTheme = () => {
    setTheme(theme.title === 'dark' ? themes.light : themes.dark)
  }

  const toggleLanguage = () => {
    i18n.language === 'pt-BR' ? i18n.changeLanguage('en-US') : i18n.changeLanguage('pt-BR')
  }

  return (
    <ThemeProvider theme={theme}>
      <Header toggleTheme={toggleTheme} toggleLanguage={toggleLanguage} />
      <Bio />
      {/* <AboutMe /> */}
      <TechStack />
      <Projects />
      {/* <Contacts /> */}

      <GlobalStyle />
    </ThemeProvider>
  );
}